import * as ExportConstants from '../constants';

const initialState = {
  isFetching: false,
  isExporting: false,
  sources: [],
  measurementTypes: []
};

export function exportsReducer(state = initialState, action) {
  switch (action.type) {
    case ExportConstants.FETCH_SOURCES_STARTED:
      return Object.assign({}, state, {isFetching: true, sources: []});
    case ExportConstants.FETCH_SOURCES_COMPLETED:
      return Object.assign({}, state, {isFetching: false, sources: action.sources});
    case ExportConstants.EXPORT_STARTED:
      return Object.assign({}, state, {isExporting: true});
    case ExportConstants.EXPORT_COMPLETED:
      return Object.assign({}, state, {isExporting: false});
    case ExportConstants.FETCH_MEASUREMENT_TYPES_STARTED:
      return Object.assign({}, state, {isFetching: true, measurementTypes: []});
    case ExportConstants.FETCH_MEASUREMENT_TYPES_COMPLETED:
      return Object.assign({}, state, {isFetching: false, measurementTypes: action.uniqueMeasurementTypes});
    case ExportConstants.EXPORT_FAILED:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
}
